if (!customElements.get("m-sharing")) {
  customElements.define(
    "m-sharing",
    class MSharing extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          shareContent: ".m-product-addon--sharing",
          openBtn: "[data-open-share]",
        };
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        const { shareContent } = this.domNodes;
        if (shareContent && shareContent.innerHTML) {
          this.shareContent = shareContent.innerHTML;
          this.init();
        }
      }

      disconnectedCallback() {
        this.removeDelegate?.();
        this.removeDelegate = null;
      }

      init() {
        this.domNodes.openBtn && this.domNodes.openBtn.classList.remove("m:hidden");
        this.modal = typeof MinimogTheme?.Modal === 'function' ? new MinimogTheme.Modal() : null;
        const delegate = typeof addEventDelegate === 'function' ? addEventDelegate : window.addEventDelegate;
        if (typeof delegate === 'function') {
          this.removeDelegate?.();
          this.removeDelegate = delegate({
            selector: this.selectors.openBtn,
            handler: (e) => {
              e.preventDefault();
              if (!this.modal && typeof MinimogTheme?.Modal === 'function') {
                this.modal = new MinimogTheme.Modal();
              }
              if (this.modal && this.shareContent) {
                const html = document.createElement("DIV");
                html.classList.add('m-sharing__content');
                html.innerHTML = this.shareContent;
                this.modal.appendChild(html);
                const colorScheme = html.querySelector('[data-color-scheme]') && html.querySelector('[data-color-scheme]').dataset.colorScheme;
                this.modal.setSizes(`m-sharing m-gradient ${colorScheme}`);
                this.modal.open();
              }
            },
          });
        }
      }
    }
  );
}
